import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";

export class UserJobExperienceModel extends Model  {
    key: string = "";
    company_name:string = "cp";
    function:string = "func sdsd";
    description:string = "";
    start_at:any = null;
    current:boolean = false;


    constructor(data = null, usertype = null) {
        super(data);
        if(data) {
            this.createModel(data);
            
        }
    }

}
